module.exports = __webpack_public_path__ + "static/media/How.fabe1390.png";